define("shared/components/shared/ui/switcher/action", ["exports", "@ember/component", "@ember/component/template-only", "@ember/template-factory"], function (_exports, _component, _templateOnly, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div class="o--dropFooter u--p__0" ...attributes>
    <Shared::Ui::Button
      @additional="block"
      @isDisabled={{@task.isRunning}}
      @onClick={{perform @task}}
      @variant="unstyled"
      class="o--dropBody__link u--text--hl"
      data-qa-id={{or @qaId ""}}
    >
      <div class="u--flex u--flex__alignItems--center">
        <span class="o--btn o--btn--c o--btn--default u--flex u--flex__justify--center u--flex__alignItems--center">
          {{#if @task.isRunning}}
            <Shared::LoadingSpinner class="u--m__t__sm u--m__l__sm" />
          {{else}}
            {{svg-jar @icon class="o--icon"}}
          {{/if}}
        </span>
        <span class="o--user__title u--text--hl u--m__l__sm">
          {{@label}}
        </span>
      </div>
    </Shared::Ui::Button>
  </div>
  */
  {
    "id": "GTx53VYq",
    "block": "[[[11,0],[24,0,\"o--dropFooter u--p__0\"],[17,1],[12],[1,\"\\n  \"],[8,[39,0],[[24,0,\"o--dropBody__link u--text--hl\"],[16,\"data-qa-id\",[28,[37,1],[[30,2],\"\"],null]]],[[\"@additional\",\"@isDisabled\",\"@onClick\",\"@variant\"],[\"block\",[30,3,[\"isRunning\"]],[28,[37,2],[[30,3]],null],\"unstyled\"]],[[\"default\"],[[[[1,\"\\n    \"],[10,0],[14,0,\"u--flex u--flex__alignItems--center\"],[12],[1,\"\\n      \"],[10,1],[14,0,\"o--btn o--btn--c o--btn--default u--flex u--flex__justify--center u--flex__alignItems--center\"],[12],[1,\"\\n\"],[41,[30,3,[\"isRunning\"]],[[[1,\"          \"],[8,[39,4],[[24,0,\"u--m__t__sm u--m__l__sm\"]],null,null],[1,\"\\n\"]],[]],[[[1,\"          \"],[1,[28,[35,5],[[30,4]],[[\"class\"],[\"o--icon\"]]]],[1,\"\\n\"]],[]]],[1,\"      \"],[13],[1,\"\\n      \"],[10,1],[14,0,\"o--user__title u--text--hl u--m__l__sm\"],[12],[1,\"\\n        \"],[1,[30,5]],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n  \"]],[]]]]],[1,\"\\n\"],[13]],[\"&attrs\",\"@qaId\",\"@task\",\"@icon\",\"@label\"],false,[\"shared/ui/button\",\"or\",\"perform\",\"if\",\"shared/loading-spinner\",\"svg-jar\"]]",
    "moduleName": "shared/components/shared/ui/switcher/action.hbs",
    "isStrictMode": false
  });
  var _default = _exports.default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());
});